export default {
    path: '/new-vendor',
    preload: false,
    middlewares: [{
        "rms_ui/validatePermissionsMiddleware": [
            ["market.vendor_create"],
            "/login"
        ]
    }],
}
